import ReactGA from "react-ga4";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const initializeAnalytics = () => {
  const consent = cookies.get('cookieConsent');
  if (consent === true) {
    ReactGA.initialize("G-TT0D9NCLMY");
  }
};

export const trackPageView = (path) => {
  const consent = cookies.get('cookieConsent');
  if (consent === true) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};